import { vars } from './vars';

/**
 * For all methods:
 *      @param {Element} dropdown - the .dropdown element to act on
 */
export const Dropdown = {
    open(dropdown) {
        this.closeAllDropdowns();
        dropdown.classList.add('is-open');
        dropdown.querySelector('.dropdown-trigger').setAttribute('aria-expanded', true);

        // If menu would be partially off-screen, make it align with right
        // Don't run if dropdown already has .is-right
        const menu = dropdown.querySelector('.dropdown-menu');
        if (!dropdown.classList.contains('is-right') && menu.getBoundingClientRect().right > window.innerWidth) {
            dropdown.classList.add('is-right');

            // Remove is-right on close
            dropdown.addEventListener('close', () => {
                dropdown.classList.remove('is-right');
            }, { once: true });
        }

        dropdown.querySelector('[tabindex="0"]')?.focus(); // focus on first focusable element

        dropdown.dispatchEvent(new Event('open', {bubbles: true}));
    },
    close(dropdown) {
        dropdown.classList.remove('is-open');
        dropdown.querySelector('.dropdown-trigger').setAttribute('aria-expanded', false);
        dropdown.dispatchEvent(new Event('close', {bubbles: true}));
    },
    closeAllDropdowns() {
        for (const el of vars.calendarShadowDom.querySelectorAll('.dropdown.is-open')) {
            this.close(el);
        }
    },
    isDisabled(dropdown) {
        return dropdown.classList.contains('is-disabled');
    },
    isOpen(dropdown) {
        return dropdown.classList.contains('is-open');
    },
    setActive(dropdown) {
        dropdown.classList.add('is-active');
    },
    setInactive(dropdown) {
        dropdown.classList.remove('is-active');
    }
};